import moment from "moment";
import _str from "shared/util/_str";

export default function makeSmartDateString(d, format) {
	const f = format || "ABSOLUTE_TIME";
	const dm = moment(d);
	const now = moment();
	const justNow = now.clone().subtract(3, "minutes");
	const today = now.clone().startOf("day");
	const yesterday = now.clone().subtract(1, "days").startOf("day");
	const lastweek = now.clone().subtract(7, "days").endOf("day");
	const thisYear = now.clone().get("year");

	const isJustNow = dm.isAfter(justNow) && dm.isBefore(now);
	const isToday = dm.isSame(today, "d");
	const isYesterday = dm.isSame(yesterday, "d");
	const isThisWeek = dm.isAfter(lastweek) && dm.isBefore(now);

	let str;

	/* eslint-disable no-fallthrough, lines-around-comment */
	switch (f) {
		// OLD ONE-OFFS
		// DO NOT USE!!!
		// "1914-12-20 08:00-03:00" for <time datetime=? />
		case "TIME_ELEMENT":
			str = moment(d).format("YYYY-MM-DD H:MMZ");
			break;

		// "8:30:34 PM"
		case "IM_FORMAT":
			str = moment(d).format("LTS");
			break;

			// ---------------------------------------------------------------------

		// OFFICIAL name
		case "ABSOLUTE_DAY":

		// old names
		case "SIMPLE_DATE":
		case "BILLING_FORMAT":
		case "MAIL_FORMAT":
		case "BRIEF_MAIL_FORMAT":
		case "BRIEF_FOR_TOOLTIP":
		case "TEST_FORMAT":
		case "PROFILE_FORMAT":
		case "DAY":
		case "BRIEF":
		case "USER_ROW":
			if (isJustNow) {
				str = _str("Just now!");
			}
			else if (isToday) {
				str = moment(d).format("LT");
			}
			else if (isYesterday) {
				str = _str("Yesterday");
			}
			else if (isThisWeek) {
				str = moment(d).format("dddd");
			}
			else {
				// "Oct 24, 1974"
				str = moment(d).format("ll");
			}
			break;

			// ---------------------------------------------------------------------

		// OFFICIAL name
		case "ABSOLUTE_TIME":

		// old names
		case "BRIEF_MAIL_WITH_TIME":
		case "HQ_CONTEST_FORMAT":
		case "HQ_BROWSE_FORMAT":
		case "MESSAGE_FORMAT":
		case "IM_PERIODIC_FORMAT":
		case "JOURNAL_FORMAT":
		case "IM_CONVERSATION_FORMAT":
			if (isJustNow) {
				str = _str("Just now!");
			}
			else if (isToday) {
				str = `${_str("Today")} - ${moment(d).format("LT")}`;
			}
			else if (isYesterday) {
				str = `${_str("Yesterday")} - ${moment(d).format("LT")}`;
			}
			else if (isThisWeek) {
				str = `${moment(d).format("dddd")} - ${moment(d).format("LT")}`;
			}
			else {
				str = moment(d).format("lll");
			}
			break;

			// ---------------------------------------------------------------------

		// OFFICIAL name
		case "RELATIVE_TIME":

		// old name
		case "AUTOBOOST_TIMES":
			str = moment(d).fromNow();
			break;

			// ---------------------------------------------------------------------

		default:
			break;
	}

	return str
		.replace(`, ${thisYear}`, "")
		.replace(` ${thisYear}`, "")
		.replace(/(AM|PM| AM| PM)/, (match) => {
			return match.toLowerCase().replace(/\s/, "");
		});
}

// Export this for things that still use it.
window.makeSmartDateString = makeSmartDateString;



// WEBPACK FOOTER //
// ./src/shared/util/makeSmartDateString.js